import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaUniversity, FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function MbaCourse() {
  const careers = [
    {
      icon: "💻",
      title: "Business Analyst",
    },
    {
      icon: "🌐",
      title: "Marketing Manager",
    },
    {
      icon: "📊",
      title: "Financial Analyst",
    },
    {
      icon: "🖥️",
      title: "Human Resource Manager",
    },
    {
      icon: "🗄️",
      title: "Operations Manager",
    },
    {
      icon: "☁️",
      title: "Project Manager",
    },
    {
      icon: "🔐",
      title: "Entrepreneur",
    },
    {
      icon: "📂",
      title: "Supply Chain Manager",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance MBA and how does it work?",
      answer:
        "A Distance MBA is a flexible postgraduate management program that lets you study business administration online or through correspondence without attending regular on-campus classes.",
    },
    {
      question: "Is a Distance MBA recognized and valid in India?",
      answer:
        "Yes. A Distance MBA from a UGC or AICTE-approved university is fully recognized and valid for employment, promotions, and higher studies in both private and government sectors.",
    },
    {
      question:
        "What are the eligibility criteria for enrolling in a Distance MBA?",
      answer:
        "Typically, candidates need a bachelor’s degree from a recognized university. Some universities may also prefer or require relevant work experience for executive MBA tracks.",
    },
    {
      question: "How long does it take to complete a Distance MBA?",
      answer:
        "Most Distance MBA programs are designed to be completed in 2 to 3 years, with flexible pacing or extended durations available depending on the university.",
    },
    {
      question: "Can I pursue a Distance MBA while working full-time?",
      answer:
        "Absolutely. Distance MBA courses are designed for working professionals, allowing you to access online lectures, digital resources, and assignments on your own schedule.",
    },
    {
      question: "What career opportunities are available after a Distance MBA?",
      answer:
        "Graduates can advance in roles such as Manager, Business Analyst, Marketing Head, Financial Consultant, HR Specialist, or even launch their own entrepreneurial ventures.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        "You don’t have to leave your job to pursue higher education. The flexible format allows you to manage both work and studies efficiently.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        "Study from any location at your convenience. All course materials, video lectures, and assignments are accessible online—no need to attend physical classes.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        "Distance education is typically more affordable than traditional on-campus programs. Yet, the degree you earn is the same and equally valid.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        "Your MCA degree comes from recognized institutions, ensuring credibility for jobs, promotions, or further studies.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        "The course content is tailored to match industry requirements with subjects like programming, software development, cloud computing, and AI.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        "You can learn at your own speed and still receive academic guidance, doubt-solving sessions, and mentorship when needed.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "Typically 2 years (4 semesters) — some universities offer extended flexibility for working professionals pursuing mba distance education in Bangalore.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        " 100% online / distance learning with live classes, recorded lectures, and digital assessments through online MBA courses in Bangalore.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Bachelor’s degree (minimum 50%) in a relevant stream from a recognized university, allowing enrollment in distance MBA colleges in Bangalore.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        " Programs offered by UGC-approved MBA online institutions, ensuring credibility for jobs, promotions, or further studies.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        " Industry-aligned syllabus covering core management principles, electives, and specializations in Finance, Marketing, HR, Supply Chain, and Entrepreneurship.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        "Self-paced learning with dedicated academic support, e-resources, and mentorship from best online MBA colleges or best MBA distance learning colleges in Bangalore.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          MBA Distance Education in Bangalore | UGC Approved Online MBA
        </title>
        <meta
          name="description"
          content="Enroll in UGC-approved MBA distance education in Bangalore. Explore top online MBA courses, correspondence programs, and best distance MBA colleges."
        />
      </Helmet>

      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Master of Business Administration (MBA)
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/487205-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "40px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              MBA Distance Education – Build the Business Leader Within
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              A Master of Business Administration (MBA) is one of the most
              sought-after postgraduate programs for professionals aiming to
              develop strategic, managerial, and leadership skills. With a focus
              on real-world applications, decision-making, and industry-relevant
              knowledge, an MBA prepares individuals to take on
              high-responsibility roles in finance, marketing, operations, human
              resources, entrepreneurship, and more. Through MBA distance
              education, learners can earn a UGC-approved MBA distance education
              degree from reputed universities while balancing work, personal
              life, or other commitments. With flexible learning schedules,
              students can access lectures, assignments, and study materials
              online, making it an ideal choice for working professionals or
              fresh graduates.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of the MBA Distance Education Program
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              MBA Distance Education – Elevate Your Future in Business &
              Management
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              An MBA through distance education offers a flexible and accessible
              pathway for individuals looking to advance their career in
              business, management, and entrepreneurship. This program is ideal
              for fresh graduates and working professionals who want to develop
              leadership, analytical, and strategic skills while balancing their
              current commitments. With MBA distance education in Bangalore,
              learners can earn a prestigious degree from UGC-approved MBA
              distance education universities—without attending regular
              classroom sessions. The curriculum is designed to be comprehensive
              and flexible, covering subjects such as Marketing Management,
              Financial Accounting, Human Resource Strategy, Operations,
              Business Analytics, and more. Students can select from multiple
              specializations to align their MBA journey with personal career
              goals. Online MBA courses in Bangalore include real-world case
              studies, project-based assessments, and virtual classrooms for an
              engaging learning experience. Flexibility is a major advantage of
              pursuing an MBA via distance mode. You can access materials
              online, attend live or recorded sessions, and complete assignments
              at your own pace. Whether you aim to climb the corporate ladder,
              switch careers, or start your own business, a degree from the best
              MBA distance learning colleges in Bangalore provides credibility,
              practical knowledge, and confidence for today’s competitive
              economy.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose MBA via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your MBA Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance MBA programs are becoming increasingly popular among
                students and working professionals who want to enhance their
                business acumen without putting their careers on hold. With
                flexible schedules, affordable fees, and access to top-quality
                education, this mode of learning is ideal for today’s fast-paced
                world.
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After MBA</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an MCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, MCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance MBA Program</h3>
            <p>
              Looking to accelerate your career in business and management? Our
              UGC-approved MBA program is crafted for ambitious professionals
              seeking expertise in leadership, strategic thinking, and
              functional business areas — all through a flexible online format.
              Whether you’re a graduate, a working executive, or someone
              planning a career shift, this program offers the affordability,
              convenience, and real-world curriculum to help you thrive. Fill
              out the form to receive expert support on admissions, course
              options, and university selection — and take the first step toward
              your MBA journey with confidence.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
